import {withFormik} from "formik";
import * as yup from "yup"
import {mobileRegExp} from "../../../services/regex"
import httpClient from "../../../services/httpClient";
import {usersApi} from "../../../constans/apiUrls";
import {INewUserData} from "../../../contracts/data/user";
import InnerCreateUserForm from "../../../components/FormTemplates/user/InnerCreateUserForm";


const newUserFormValidationSchema = yup.object().shape({
    mobile: yup.string().required("شماره موبایل الزامی میباشد").length(11, "شماره موبایل 11 رقم میباشد").matches(mobileRegExp, "شماره موبایل نادرست میباشد"),
    first_name: yup.string().required("نام الزامی میباشد"),
    last_name: yup.string().required("نام خانوادگی الزامی میباشد"),
})

interface INewUserFormProps {
    handleChangeSuccess: any
}

const CreateUserForm = withFormik<INewUserFormProps, INewUserData>({
    mapPropsToValues: props => ({
        mobile: '',
        first_name: '',
        last_name: '',
    }),
    mapPropsToStatus: props => ({}),
    validationSchema: newUserFormValidationSchema,
    handleSubmit: async (values, formikBag) => {
        await httpClient().post(usersApi.create, values)
            .then(response => {
                if(response.status === 201 || response.status === 200 ){
                    formikBag.setStatus({
                        ...formikBag.props,
                        result: response?.data
                    })
                    formikBag.props.handleChangeSuccess(response?.data?.data)
                }
            })
            .catch(error => {
                formikBag.setStatus({
                    ...formikBag.props,
                    result: error?.response?.data
                })
            })
    },
    displayName: 'CreateUserForm'
})(InnerCreateUserForm)

export default CreateUserForm